<template>
  <div class="row">
      <div class="col-md-12 card">
          <div class="card-header">
               <div class="row">
                   <div class="col-lg-10 col-md-10 col-sm-8 col-xs-12">
                      <h5 class="card-title">{{ $t('farmer_details') }}</h5>
                   </div>
                   <div v-show="showButton == 0" class="col-lg-2 col-md-2 col-sm-4 col-xs-12 text-center">
                      <a class="btn btn-xs text-white" style="background-color:red" @click.prevent="goBackTrainer()">
                        <i class="fa fa-backward"></i>
                        {{ $t('back') }}
                      </a>
                   </div>
                   <div v-show="showButton == 1" class="col-lg-2 col-md-2 col-sm-4 col-xs-12 text-center">
                      <a class="btn btn-xs text-white" style="background-color:red" @click.prevent="goBackFarmer()">
                        <i class="fa fa-backward"></i>
                        {{ $t('back') }}
                      </a>
                   </div>
               </div>
          </div>
          <div class="card-body">
              <table class="table table-bordered" v-loading="loading_farmers" element-loading-text="Loading data...">
                  <tbody>
                      <tr v-show="userDetails.profile">
                        <td colspan="2">
                          <img :src="userDetails.profile" class="img-responsive img-fluid" width="70px" height="70px" alt="Profile">
                        </td>
                      </tr>
                      <tr>
                         <th width="200px">{{ $t('name') }}</th>
                         <td>{{ userDetails.name }} </td>
                      </tr>
                      <tr>
                         <th>{{ $t('surname') }}</th>
                         <td>{{ userDetails.last_name }} </td>
                      </tr>
                      <tr>
                         <th>{{ $t('email') }}</th>
                         <td>{{ userDetails.email }}</td>
                      </tr>
                      <tr>
                         <th>{{ $t('phone') }}</th>
                         <td>{{ userDetails.phone }}</td>
                      </tr>
                      <tr>
                         <th>{{ $t('country') }}</th>
                         <td>{{ userDetails.country }}</td>
                      </tr>
                      <tr>
                         <th>{{ $t('community') }}</th>
                         <td>{{ userDetails.community }}</td>
                      </tr>
                      <tr>
                         <th>{{ $t('hectares') }}</th>
                         <td>{{ userDetails.hectares }}</td>
                      </tr>
                      <tr>
                         <th>{{ $t('people') }}</th>
                         <td>{{ userDetails.people }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>

      <div class="col-md-12 card">
          <div class="card-header">
               <h5 class="card-title">{{ $t('harvests') }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                      </el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm" placeholder="Search" v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split"
                    ></fg-input>
                  </div>
                </div>
             </div>
            <div class="row">
                  <el-table v-loading="loading_harvests" :element-loading-text="$t('loading_data')+'...'" class="table-striped" :data="paginated" border style="width: 100%">
                    <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                      :prop="column.prop" :label="column.label" sortable="">
                    </el-table-column>
                  </el-table>
             </div>
          </div>
           <div class="card-footer">
            <div class="row">
                <div class="col-sm-6 pagination-primary">
                  <p class="category">{{ $t('showing') }} {{pagination.from}} {{ $t('to') }} {{pagination.to}} of {{pagination.total}} {{ $t('entries') }}</p>
                </div>
                <div class="col-sm-6">
                  <p-pagination
                    class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total"></p-pagination>
                </div>
             </div>
          </div>
      </div>

  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
import PPagination from "src/components/UIComponents/Pagination.vue";
const HarvestResource = new Resource("post/givenPostId/Harvest");
import { fetchPage } from "@/util/Api/page.js";
export default {
  components:{
    PPagination,
  },
  data() {
    return {
       farmer:{},
       form:{},
       post:{},
       harvest:[],
       tableData: [],
       searchQuery:'',
       tableColumns: [
          {prop: "cropName",label: this.$t("crops"),},
          {prop: "month",label: this.$t("month"),},
          {prop: "year",label: this.$t("year"),},
          {prop: "amount",label: this.$t("amount_ton"),},
          {prop: "people",label: this.$t("household"),},
          {prop: "landSize",label: this.$t("land_size_hectare")},
       ],
       userDetails: {
         id:'',
         name:'',
         surname: '',
         first_name: '',
         last_name: '',
         profile:'',
         email:'',
         phone:'',
         hectares:'',
         people:'',
         harvest:'',
         ngo:'',
         country:'',
         community:'',
       },
       harvestDetails: [],
       pagination: {
            perPage: 10,
            perPageOptions: [10, 20, 30, 60, 500, 1000],
            currentPage:1,
            nextPage:'',
            prevPage:'',
            total:'',
            from:'',
            to:'',
            page:'',
       },
       loading: false,
       loading_harvests: false,
       loading_farmers: false,
       showButton: localStorage.getItem("showButton"),
       farmerPostID: '',
       harvestDetails: {
          id:'',
          cropName:'',
          month:'',
          year:'',
          amount:'',
          people:'',
          landSize:'',
          appliedFIFTraining:'',
          postTemplateID: ''
       },
       allHarvests: []
    }
  },

  mounted() {
     this.userDetails = this.$route.params.post;
     this.farmerPostID = this.userDetails.id;
     if(this.farmerPostID) {
        this.farmerHarvest();
     }
  },


  methods: {
    // function to go back to previuos page
    goBackFarmer() {
        this.$router.push({name: "ReportFarmers"});
    },

    goBackTrainer() {
        this.$router.push({name: "TrainerDetail"});
    },

    // Parse data
    parseAnswer(answer) {
        let data = "";
        if(answer.indexOf('"') > -1) {
           data = JSON.parse(answer);
        } else {
           data = answer;
        }
        return data;
    },

    // format data
    formatHarvestData(harvests) {
      this.allHarvests = [];
      harvests.forEach(harvest => {
        this.harvestDetails = [];
        this.harvestDetails.id = harvest.post.id;
        this.harvestDetails.postTemplateID = harvest.post.postTemplateID;

        harvest.postContent.forEach(element => {
                  if(element.Question.title.toLowerCase() === "select crop") {
                      if(element.Answer) {
                         this.harvestDetails.cropName = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.cropName = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "select month") {
                      if(element.Answer) {
                        this.harvestDetails.month = this.parseAnswer(element.Answer);
                      } else {
                        this.harvestDetails.month = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "select year") {
                      if(element.Answer) {
                        this.harvestDetails.year = this.parseAnswer(element.Answer);
                      } else {
                        this.harvestDetails.year = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "amount (tons)") {
                      if(element.Answer) {
                         this.harvestDetails.amount = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.amount = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "land size (hectares)") {
                      if(element.Answer) {
                         this.harvestDetails.landSize = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.landSize  = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "people in household") {
                    if(element.Answer) {
                         this.harvestDetails.people = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.people = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "applied fif training") {
                      if(element.Answer) {
                        this.harvestDetails.appliedFIFTraining = this.parseAnswer(element.Answer);
                      } else {
                        this.harvestDetails.appliedFIFTraining;
                      }
                  }
            });

            this.allHarvests.push(this.harvestDetails);
        });

        this.tableData = this.allHarvests;
    },

    // Getting the farmer harvest
    async farmerHarvest() {
        this.loading_harvests = true;
        await HarvestResource.get(this.farmerPostID)
          .then(response => {
            let allHarvests = response.data;
            this.formatHarvestData(allHarvests);
            this.loading_harvests = false;
        }).catch(error => {
            console.log("Error: ", error);
        });
    },

    capitalize(word) {
       if (typeof word !== 'string') return ''
       return word.charAt(0).toUpperCase() + word.slice(1);
    },

    paginate(array, length, pageNumber) {
        this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
        this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
        this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
        this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
        this.pagination.page = Math.ceil(array.length / length);
        this.pagination.total = array.length;
        return array.slice((pageNumber - 1) * length, pageNumber * length);
    },

  },

  computed: {
    filterData() {
        let result = this.tableData;
        if (this.searchQuery) {
            result = result.filter((row) => {
                return Object.keys(row).some((key) => {
                    return (String(row[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
                })
            });
        }

        return result;
    },

    paginated(){
        return this.paginate(this.filterData, this.pagination.perPage, this.pagination.currentPage);
    },
  },
}
</script>
